import { ApiError } from '../api/client.js';

type T = (key: string, opts?: Record<string, unknown>) => string;

/** Turn `discover_failed:<reason>` from the API into a human sentence (why, not just "nothing found"). */
export function describeDiscoverError(err: unknown, t: T): string {
  const code = err instanceof ApiError ? err.code : 'generic';
  const reason = code.startsWith('discover_failed:') ? code.slice('discover_failed:'.length) : 'generic';
  const http = /^http_(\d+)$/.exec(reason);
  if (http) return t('sources.discoverFailed', { reason: t('sources.discoverReason.http', { status: http[1] }) });
  const known = ['timeout', 'network', 'private_ip', 'invalid_feed', 'too_large'];
  const key = known.includes(reason) ? reason : 'generic';
  return t('sources.discoverFailed', { reason: t(`sources.discoverReason.${key}`) });
}
